import React, {useContext, useEffect} from "react";
import {Input, Layout, Select} from "antd";
import UserLoginContext from "../../../context/userLoginContext";
import EmployeeSearchTable from "./utils/employee-search-table";
import SearchCriteria from "../../common/search-criteria/search-criteria";
import {searchCriteria} from "./utils/utils";
import {SearchParams} from "../../common/search-criteria/type/search-criteria.type";
import ToggleEmployeeStatus from "./utils/toggle-employee-status";
import server from "../../../server";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IEmployeeSearchViewProps {
    isActiveEmployees: boolean;
    toggleActiveAndInactiveEmployees: (value: boolean) => void;
    pageNumber: number;
    pageSize: number;
    employeeResponse: any;
    handleNextPage: () => void;
    handlePrevPage: () => void;
    handleSearch: (params: SearchParams) => Promise<void>;
    headingChange: boolean;
    handleReset: () => void;
    appliedActiveStatus: boolean;
    onSortChange: any;
    loading: boolean;
    sortField:string;
    sortDirection:"ASC" | "DESC"|undefined;
}

function EmployeeSearchView(props: IEmployeeSearchViewProps) {
    const {user} = useContext(UserLoginContext);
    const [countryCodes, setCountryCodes] = React.useState<any[]>([]);

    useEffect(() => {
        loadCountryCodes();
    }, []);

    async function loadCountryCodes() {
        try {
            const res = await server.utils.countriesnow.getAllCountriesDialCodeAndFlag();
            const formatted = (res.data || []).flatMap((item: any) => {
                const codes = item.dialCode
                    ?.split(/and|,/i)
                    .map((c: string) => c.trim())
                    .filter(Boolean) || [];

                return codes.map((code: string) => ({
                    value: code,
                    label: (
                        <div key={code} className={'country-code-dropdown'}>
                            <img src={item.flag} width={20} height={15} alt="flag"/>
                            <span>{code}</span>
                        </div>
                    )
                }));
            });

            const unique = Array.from(
                new Map(formatted.map((i: any) => [i.value, i])).values()
            );

            setCountryCodes(unique);
        } catch (err) {
            console.error("Country code fetch failed", err);
        }
    }

    return (
        <Layout className="with-background">
            <div className="data-table employee-search">
                <SearchCriteria
                    searchCriteria={searchCriteria}
                    onSearch={props.handleSearch}
                    onReset={props.handleReset}
                    showReset={true}
                    title={"Search Employee"}
                    renderTopContent={({values, onChange}) => (
                        <>
                            <div>
                                <label className={"label"}> Name</label>
                                <Input
                                    placeholder="Enter name"
                                    value={values.name || ''}
                                    onChange={(e) => onChange('name', e.target.value)}
                                />
                            </div>

                            <div>
                                <label className={"label"}> Employee Code</label>
                                <Input
                                    placeholder="Enter employee code"
                                    value={values.employeeCode || ''}
                                    onChange={(e) => onChange('employeeCode', e.target.value)}
                                />
                            </div>

                            <div>
                                <label className={"label"}> Official Email</label>
                                <Input
                                    placeholder="Enter official email"
                                    value={values.officialEmail || ''}
                                    onChange={(e) => onChange('officialEmail', e.target.value)}
                                />
                            </div>
                            {
                                user?.isAdmin && <div>
                                    <ToggleEmployeeStatus
                                        activeStatus={props.isActiveEmployees}
                                        setActiveStatus={(val) => {
                                            props.toggleActiveAndInactiveEmployees(val);
                                            onChange("active", val);
                                        }}
                                    />
                                </div>
                            }
                        </>
                    )}
                    renderInputForCriteria={(criteria, {values, onChange}) => {
                        if (criteria.key === 'mobile') {
                            return (
                                <Input.Group compact>
                                    <Select
                                        style={{width: '35%'}}
                                        value={values.mobile?.countryCode || '+91'}
                                        options={countryCodes}
                                        showSearch
                                        onChange={(val) =>
                                            onChange('mobile', {
                                                ...values.mobile,
                                                countryCode: val,
                                            })
                                        }
                                    />

                                    <Input
                                        style={{width: '65%'}}
                                        placeholder="Enter mobile number"
                                        value={values.mobile?.mobileNumber || ''}
                                        maxLength={10}
                                        onChange={(e) => {
                                            const onlyNumber = e.target.value.replace(/\D/g, '');
                                            onChange('mobile', {
                                                ...values.mobile,
                                                mobileNumber: onlyNumber,
                                            });
                                        }}
                                    />
                                </Input.Group>
                            );
                        }
                        return null;
                    }}
                />
                <div className={"heading-and-switchIcon"}>

                    <h4 className={"employee-table-heading"}>{props.headingChange ? 'Showing search results' : 'List of Employees'}
                    </h4>

                    <div className="search-result-list">
                        <LoadingSkeleton loading={props.loading}>
                            <EmployeeSearchTable
                                sortField={props.sortField}
                                sortDirection={props.sortDirection}
                                employeeResponse={props.employeeResponse}
                                pageNumber={props.pageNumber}
                                pageSize={props.pageSize}
                                onSortChange={props.onSortChange}
                                handleNextPage={props.handleNextPage}
                                handlePrevPage={props.handlePrevPage}
                                isActiveEmployees={props.appliedActiveStatus}
                            />
                        </LoadingSkeleton>

                    </div>
                </div>

            </div>
        </Layout>
    )
}

export default EmployeeSearchView;
